// ink-component
import React from 'react';
import { Moment } from 'moment';

import { defaultShortcuts } from '../../../_common/CoreDatePicker/Calendar/Constants';
import CoreDatePicker from '../../../_common/CoreDatePicker/CoreDatePicker';
import { Shortcut } from '../../../_common/CoreDatePicker/Calendar/CalendarShortcuts/CalendarShortcuts';

type CustomDate = Date | Moment | string;

/* Prop interface naming exception */
export interface NewCalendarShortcutsProps {
  /** Callback for closing the calendar */
  closeCalendar: () => void;
  /** Callback for clicking a date */
  onDateClick: (e: any | MouseEvent, date: CustomDate) => void;
  /** Override default's shortcuts */
  shortcuts?: Array<Shortcut>;
}

/**
 * @purpose Allows users to choose dates from shortcuts
 * @categories form
 * @group NewDatePicker
 */
function CalendarShortcuts(props: NewCalendarShortcutsProps) {
  // @ts-ignore
  const { className, style, ...otherProps } = props;

  return <CoreDatePicker.Shortcuts {...otherProps} />;
}

CalendarShortcuts.defaultProps = {
  shortcuts: defaultShortcuts,
};

CalendarShortcuts.displayName = 'NewDatePicker.Shortcuts';

export default CalendarShortcuts;
